<template>
  <vs-popup
    class="holamundo"
    title="Update Service Request Details:"
    :active="isOpen"
    @close="close"
  >
    <vs-textarea
      v-validate="'required'"
      label="Work Needed"
      class="w-full"
      placeholder="What issue are you experiencing with the Ventilator?"
      v-model="form.workRequired"
      name="workRequired"
    />
    <span class=" ml-1 text-danger text-sm" v-show="errors.has('workRequired')"
      >You need to enter the work that is required</span
    >

    <SelectWithLabel
      v-validate="'required'"
      name="status"
      v-model="form.status"
      :options="serviceRequestStatusList"
      title-text="Request Status:"
      validation-text="You need to select a status for the request"
      :show-validation="errors.has('status')"
    />

    <SelectWithLabel
      v-validate="'required'"
      name="priority"
      v-model="form.priority"
      :options="serviceRequestPriorityList"
      title-text="Request priority:"
      validation-text="You need to select a priority for this request"
      :show-validation="errors.has('priority')"
    />

    <SelectWithLabel
      openDirection="below"
      v-model="form.assigneeUser"
      entity-name="user"
      label="name"
      :options="userList"
      title-text="Assigned User:"
      validation-text=""
    />

    <vs-row class="mt-2">
      <vs-col
        vs-type="flex"
        vs-justify="space-between"
        vs-align="center"
        vs-w="12"
      >
        <vs-button color="danger" type="border" @click="close"
          >Cancel</vs-button
        >
        <vs-button
          color="success"
          class="ml-2"
          type="filled"
          @click="submitForm"
          >Save</vs-button
        >
      </vs-col>
    </vs-row>
  </vs-popup>
</template>

<script>
import { mapState } from "vuex";
import { mapGetters } from "vuex";
import { ValidationProvider } from "vee-validate";
import SelectWithLabel from "@/components/general-components/form-controls/SelectWithLabel";
import { ServiceRequest } from "../class-definitions/serviceRequest";

export default {
  name: "UpdateServiceRequestModal",
  components: {
    SelectWithLabel,
    ValidationProvider
  },
  props: {
    serviceRequest: {
      type: ServiceRequest,
      default() {
        return new ServiceRequest();
      }
    }
  },
  data() {
    return {
      isOpen: false,
      form: {
        workRequired: "",
        status: "",
        priority: null,
        assigneeUser: null
      }
    };
  },
  computed: {
    ...mapState([
      "serviceRequestPriorityList",
      "serviceRequestStatusList",
      "AppActiveUser",
      "userList"
    ]),
    ...mapGetters(["team"])
  },
  methods: {
    open() {
      this.form.workRequired = this.serviceRequest.workRequired;
      this.form.status = this.serviceRequest.status;
      this.form.priority = this.serviceRequest.priority;
      this.form.assigneeUser = this.serviceRequest.assigneeUser;
      this.isOpen = true;
      document.body.classList.add("modal-open");
    },
    close() {
      this.isOpen = false;
      document.body.classList.remove("modal-open");
    },
    submitForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.serviceRequest.workRequired = this.form.workRequired;
          this.serviceRequest.status = this.form.status;
          this.serviceRequest.priority = this.form.priority;
          this.serviceRequest.assigneeUser = this.form.assigneeUser;

          this.serviceRequest
            .save()
            .then(() => {
              this.close();
            })
            .catch(error => {
              console.error(error);
            });
        } else {
          console.error(result);
        }
      });
    }
  }
};
</script>

<style></style>
